import { QueryKeys } from '../../../queryKeys';
import { getRequest } from '../../../helpers/apiClient';
import apiRoutes from '../../../api-routes';
import { useQueryWithLogout } from '../../../hooks/useQueryWithLogout';

export const useUsersList = (filters, options) => {
  return useQueryWithLogout([QueryKeys.USERS_LIST, filters], async () => {
      const { data } = await getRequest({
        url: apiRoutes.USER,
        params: filters,
      });

      return data;
    },
    options,
  );
};
